<template>
    <div class="d-flex overflow-hidden">
        <div class="d-flex justify-content-center align-items-center shrink-0" style="width: 40px">
            <icon name="cil-location-pin" class="text-muted" />
        </div>
        <div class="overflow-hidden">
            <div>
                <b class="text-truncate d-block">{{ title }}</b>
            </div>
            <small class="text-truncate d-block text-muted">{{ description }}</small>
        </div>
    </div>
</template>
<script>
export default {
    name: 'asset.location.changed',
    props: {
        notification: {},
    },
    computed: {
        title() {
            return this.notification.payload.asset;
        },
        description() {
            let { type, payload } = this.notification;

            return this.trans(`notification.${type}`, payload);
        },
    },
};
</script>
